export default function R_Strings() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">R_Strings Component</h1>
      <p>This is the R_Strings tutorial section.</p>
    </div>
  );
}
